import { combineReducers } from 'redux';
import MainFiltersReducer from './main-filter/MainFiltersReducer';
import MainFiltersRoReducer from './main-filter-retailer-overview/MainFiltersRoReducer';
import SideFiltersReducer from './side-filters/SideFiltersReducer';
import InitialFiltersReducer from './initial-filter/InitialFiltersReducer';
import InitialFiltersProductsReducer from './initial-filter-products/InitialFiltersProductsReducer';
import MainFiltersProductsReducer from './main-filter-products/MainFiltersProductsReducer';
import RetailerClientReducer from './retailer-client/RetailerClientReducer';
import HitlistsRetailerClientReducer from './hitlist-retailer-client/HitlistsRetailerClientReducer';
import SubscribedProductTypesReducer from './subscribed-product-types/SubscribedProductTypesReducer';
import RetailKadClientReducer from './retail-kad-client/RetailKadClientReducer';
import MarketPremiumRetailerClientReducer from './market-premium-retailer-client/MarketPremiumRetailerClientReducer';
import SellerInsightsRetailerClientReducer from './seller-insights-retailer-client/SellerInsightsRetailerClientReducer';
import InitialFilterMarketPremiumReducer from './initial-filter-market-premium/InitialFilterMarketPremiumReducer';
import MainFiltersMarketPremiumReducer from './main-filter-market-premium/MainFiltersMarketPremiumReducer';
import MultiCountryLatestTimeFrameReducer from './multi-country-latest-timeframe/MultiCountryLatestTimeFrameReducer';
import availabilityPgReducer from '../feature/availability-pg/AvailabilityPgSingleCountrySlice';
import availabilityCountryReducer from '../feature/availability-country/AvailabilityCountrySlice';
import exportImagesSlice from '../feature/export-chart-images/ExportImagesSlice';

const Reducers = combineReducers({
  subscribedProductTypes: SubscribedProductTypesReducer,
  mainFilters: MainFiltersReducer,
  mainFiltersRO: MainFiltersRoReducer,
  mainFiltersProducts: MainFiltersProductsReducer,
  mainFiltersMarketPremium: MainFiltersMarketPremiumReducer,
  sideFilters: SideFiltersReducer,
  initialFilters: InitialFiltersReducer,
  initialFiltersProducts: InitialFiltersProductsReducer,
  initialFiltersMarketPremium: InitialFilterMarketPremiumReducer,
  retailerClient: RetailerClientReducer,
  hitlistsRetailerClient: HitlistsRetailerClientReducer,
  retailKadClient: RetailKadClientReducer,
  marketPremiumRetailerClient: MarketPremiumRetailerClientReducer,
  sellerInsightsRetailerClient: SellerInsightsRetailerClientReducer,
  multiCountryLatestTimeFrame: MultiCountryLatestTimeFrameReducer,
  availabilityPg: availabilityPgReducer,
  availabilityCountry: availabilityCountryReducer,
  exportImages: exportImagesSlice,
});

export default Reducers;
export type IRootState = ReturnType<typeof Reducers>;
export type MainFiltersStateKeys = 'mainFilters' | 'mainFiltersRO' | 'mainFiltersProducts' | 'mainFiltersMarketPremium';
export type RetailerClientStateKeys =
  | 'retailerClient'
  | 'hitlistsRetailerClient'
  | 'retailKadClient'
  | 'marketPremiumRetailerClient'
  | 'sellerInsightsRetailerClient';
